module.exports = __webpack_public_path__ + "media/images/flags/4x3/abw-1a9556538e743fac12f73ac3d9755d13.svg";